import { assert_string_not_empty, assert_type_enum, assert_type_string } from '@shared/asserts/utils_asserts';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { IWord } from './IWord';

export class DTO__word extends DTO__database_entity implements IWord {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.WORD;

  /*
   * STATIC METHODS
   */

  static create_english_words_from_array_of_english_strings(items: string[]): DTO__word[] {
    let out = [];

    for (let item of items) {
      let word = new DTO__word();
      word.word_english = item;
      word.word_translated = item;
      word.language = ENUM__language_type.ENGLISH;

      out.push(word);
    }

    return out;
  }

  /*
   * FIELDS
   */
  language!: string;

  word_english!: string;
  word_translated!: string;

  description_english!: string;
  description_translated!: string;

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_type_enum(this.language, ENUM__language_type);

    assert_string_not_empty(this.word_english);
    assert_type_string(this.word_translated);
  }
}
